import { useEffect, useState } from 'react';
import api from '../../service/apiService';

export default function VerifyEmail() {
  const [message, setMessage] = useState('Verifying your email...');

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get('token');
    if (!token) {
      setMessage('Missing verification token.');
      return;
    }

    api
      .verifyEmail(token)
      .then((data) => setMessage(data.message || data.error || 'Verification complete'))
      .catch((err) => {
        console.error('verifyEmail error:', err);
        setMessage('Verification failed. Please try again.');
      });
  }, []);

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}
    >
      <h2>{message}</h2>
    </div>
  );
}
